import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import PersonIcon from "@material-ui/icons/Person";
import DesktopWindowsIcon from "@material-ui/icons/DesktopWindows";
import ScreenShareIcon from "@material-ui/icons/ScreenShare";

const typoStyle = makeStyles((theme) => ({
  typography: {
    color: "#eee",
    paddingBottom: "0.5rem",
  },
}));
const paperStyle =makeStyles((theme) => ({
  paper: {
    width: "auto",
    height: "auto",
    background: "#3a3a3a",
    overflow: "hidden",
    padding: 0,
  },
}));
export default function ScreenshareOptionsPop(props) {
  const typographyStyle = typoStyle();
  const popoverStyles = paperStyle();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { layout } = props;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <Button startIcon={<ScreenShareIcon />} aria-describedby={id} variant="contained" style={{ background: "#17171794", margin: -8, color: "#fff" }} onClick={handleClick}>
        <SystemLabel name="DisplayMode" />
      </Button>
      <Popover
        id={id}
        open={open}
        classes={popoverStyles}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div
          className="dark-scroll"
          style={{
            padding: "15px",
            overflowY: "auto",
            maxHeight: "100%",
            display: "flex",
          }}
        >
          <div style={{ padding: 5 }}>
            <Typography className={typographyStyle.typography}>
              <SystemLabel name="ShowSingleSpeaker" />
            </Typography>
            <SingleSpeaker {...props} />
          </div>
          <div style={{ padding: 5 }}>
            <Typography className={typographyStyle.typography}>
              <SystemLabel name="MultiSpeakerTop" />
            </Typography>
            <MultiSpeakerTop {...props} />
          </div>
          <div style={{ padding: 5 }}>
            <Typography className={typographyStyle.typography}>
              <SystemLabel name="MultiSpeakerBottom" />
            </Typography>
            <MultiSpeakerBottom {...props} />
          </div>
          <div style={{ padding: 5 }}>
            <Typography className={typographyStyle.typography}>
              <SystemLabel name="ShowNoSpeaker" />
            </Typography>
            <NoSpeaker {...props} />
          </div>
        </div>
      </Popover>
    </div>
  );
}

const SingleSpeaker = ({ onChange, layout }) => {
  return (
    <div onClick={() => onChange("singleSpeaker")} className={"single-speaker" + (layout == "singleSpeaker" ? " active" : "")}>
      <div className="wrap">
        <div className="speaker">
          <PersonIcon />
        </div>
      </div>
      <div className="screen">
        <DesktopWindowsIcon />
      </div>
    </div>
  );
};
const MultiSpeakerTop = ({ onChange, layout }) => {
  return (
    <div onClick={() => onChange("multiSpeakersTop")} className={"single-speaker" + (layout == "multiSpeakersTop" ? " active" : "")}>
      <div className="wrap">
        <div className="speaker">
          <PersonIcon />
        </div>
        <div className="speaker">
          <PersonIcon />
        </div>
        <div className="speaker">
          <PersonIcon />
        </div>
      </div>
      <div className="screen">
        <DesktopWindowsIcon />
      </div>
    </div>
  );
};
const MultiSpeakerBottom = ({ onChange, layout }) => {
  return (
    <div onClick={() => onChange("multiSpeakersBottom")} className={"single-speaker" + (layout == "multiSpeakersBottom" ? " active" : "")}>
      <div className="screen">
        <DesktopWindowsIcon />
      </div>
      <div className="wrap">
        <div className="speaker">
          <PersonIcon />
        </div>
        <div className="speaker">
          <PersonIcon />
        </div>
        <div className="speaker">
          <PersonIcon />
        </div>
      </div>
    </div>
  );
};

const NoSpeaker = ({ onChange, layout }) => {
  return (
    <div onClick={() => onChange("noSpeakers")} className={"single-speaker" + (layout == "noSpeakers" ? " active" : "")}>
      <div className="screen" style={{ height: 112 }}>
        <DesktopWindowsIcon />
      </div>
    </div>
  );
};
